<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getInvoiceList } from "@/api/invoice";
import { money_format, dateFormatUnix } from "@/utils";
import moment from "moment";
export default {
  name: "invoice-list",
  data() {
    return {
      search: "",
      headers: [
        { text: "Amount", value: "total" },
        { text: "Status", value: "status" },
        { text: "Paid", value: "paid" },
        { text: "Invoice number", value: "number" },
        { text: "Pdf", value: "pdf" },
        { text: "Date created", value: "date" },
        { text: "Due date", value: "due_date" }
      ],
      items: []
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Invoice List" }]);
    const response = await getInvoiceList();
    this.items = response && response.data ? response.data : [];
  },
  computed: {
    invoiceItems() {
      return [
        ...this.items.map(item => {
          return {
            total: this.moneyFormat(item.total),
            status: item.status,
            paid: this.paidStatus(item.paid),
            number: item.number,
            date: this.dateFormatUnix(item.date),
            due_date: this.dateFormatUnix(item.due_date),
            id: item.id,
            hosted_invoice_url: item.hosted_invoice_url,
            invoice_pdf: item.invoice_pdf
          };
        })
      ];
    }
  },
  methods: {
    moneyFormat(value) {
      return money_format(parseFloat(value));
    },
    dateFormatUnix(value) {
      return dateFormatUnix(value);
    },
    paidStatus(value) {
      return value ? "YES" : "NO";
    },
    exporItems() {
      let csv = this.$papa.unparse(this.invoiceItems);
      this.$papa.download(
        csv,
        `InvoiceList-${moment().format("YYYY-MM-DD-HH-mm")}`
      );
    }
  }
};
</script>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-card elevation="2" class="">
        <v-card-title>
          <span class="title font-weight-bold">
            INVOICE
          </span>
        </v-card-title>

        <div>
          <div
            class="btn-toolbar justify-content-between pl-2 pr-2 mb-2"
            role="toolbar"
            aria-label="Toolbar with button groups"
          >
            <div class="btn-group" role="group" aria-label="First group">
              <v-btn class="mr-4" depressed tile small @click="exporItems()">
                <v-icon left> mdi-file </v-icon>
                Export
              </v-btn>
            </div>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" id="btnGroupAddon2">
                  <b-icon icon="search"></b-icon>
                </div>
              </div>
              <b-form-input
                v-model="search"
                placeholder="Search"
              ></b-form-input>
            </div>
          </div>
          <v-data-table
            height="200"
            :headers="headers"
            fixed-header
            :items="invoiceItems"
            :items-per-page="5"
            :hide-default-header="false"
            :search="search"
          >
            <template v-slot:item.number="{ item }">
              <a :href="item.hosted_invoice_url" target="_blank">
                {{ item.number }}
              </a>
            </template>

            <template v-slot:item.pdf="{ item }">
              <a :href="item.invoice_pdf" target="_blank">
                <v-icon left> mdi-file-pdf </v-icon>
              </a>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-main>
  </v-app>
</template>
